module.exports = __webpack_public_path__ + "static/media/043-email-2.19562737.svg";